import ChipInput from './ChipInput.component';

export default ChipInput;
